export const Excluded_Changeable_Fields_For_Property: string[] = [
    `ShortQualifier`,
    `Qualifier`,
    'PrimaryLine'
]